/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GIFT_CARD_BALANCE_QUERY = gql`
  query checkGiftcardBalance($cardNumber: String!, $gRepcaptchaResponse: String) {
    checkGiftcardBalance(cardNumber: $cardNumber, gRepcaptchaResponse: $gRepcaptchaResponse)
  }
`;